<template>
  <email-filter
    :options="smsActivityTypeOptions"
    :title="t('COMMON.TYPE')"
    placeholder-key="ACTIVITY.FILTERS.TYPE"
    :render-component="SmsTypeOption"
    query-key="sms_types[]"
    :toggle-from-parent
    is-multiple
  />
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n";

import { smsActivityTypeOptions } from "@/helpers/constants/sms";

import EmailFilter from "@/components/communicationLogs/filters/emailFilters/EmailFilter.vue";
import SmsTypeOption from "@/components/communicationLogs/filters/smsFilters/SmsTypeOption.vue";

const { toggleFromParent = false } = defineProps<{
  toggleFromParent?: boolean;
}>();

const { t } = useI18n();
</script>
